<template>
  <div v-if="memoria" :class="['memoria-container']">
    <label v-if="titulo">{{ titulo }}</label>
    <p :class="[{ negrito: negrito }]" v-html="memoria"></p>
  </div>
</template>

<script>
export default {
  name: "Memoria",

  props: {
    titulo: String,
    memoria: String,
    porcentagem: Number,
    negrito: Boolean
  },

  data() {
    return {};
  },

  mounted() {},

  computed: {
    valor() {
      if (this.porcentagem) {
        return (
          parseFloat(this.memoria)
            .toFixed(this.porcentagem)
            .toString()
            .replace(".", ",") + "%"
        );
      }
      return;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.memoria-container {
  label {
    font-size: 1rem;
    font-weight: 600;
  }
  .negrito {
    font-weight: 600;
  }
}
</style>
